// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-audio.card-loader>div[data-v-4205f5be]{border-radius:.5rem;box-shadow:0px 2px 8px rgba(1,3,20,.16)}.ui-dark .card-audio.card-loader>div[data-v-4205f5be]{box-shadow:0px 2px 8px rgba(250,250,251,.08)}@media(min-width: 1200px){.card-audio.card-loader>div[data-v-4205f5be]{height:5.5rem}}@media(max-width: 1199.9999px){.card-audio.card-loader>div[data-v-4205f5be]{height:4.0625rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
